import { createI18n } from 'vue-i18n'

// Çeviriler shared/ altından geliyor: aynı JSON'ları Flutter da okuyor.
// İki istemcide iki ayrı metin listesi tutmak, birinde düzeltilen bir ifadenin
// diğerinde eski kalması demektir.
import en from '@shared/locales/en.json'
import tr from '@shared/locales/tr.json'

export const SUPPORTED_LOCALES = ['tr', 'en'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export function resolveLocale(candidate: string | null | undefined): SupportedLocale {
  const normalized = (candidate ?? '').toLowerCase().split(/[-_]/)[0]
  return SUPPORTED_LOCALES.includes(normalized as SupportedLocale)
    ? (normalized as SupportedLocale)
    : 'tr'
}

/**
 * Paylaşılan çevirileri vue-i18n'in beklediği biçime uyarlar.
 *
 * shared/locales düz metindir ve bunu böyle tutmak zorundayız: aynı dosyaları
 * Flutter (easy_localization) da okuyor ve onun sözdizimi farklı. vue-i18n ise
 * `@` karakterini "linked message" başlangıcı sayar — "ornek@eposta.com" gibi
 * masum bir metin derleme hatası verir.
 *
 * Bu yüzden `@` yükleme anında vue-i18n'in kaçış biçimine ({'@'}) çevrilir.
 * Alternatif, paylaşılan dosyaya vue-i18n kaçışını yazmaktı; o zaman da
 * Flutter ekranda "{'@'}" gösterirdi.
 */
function adaptForVueI18n<T>(messages: T): T {
  if (typeof messages === 'string') {
    return messages.replace(/@/g, "{'@'}") as T
  }
  if (Array.isArray(messages)) {
    return messages.map(adaptForVueI18n) as T
  }
  if (messages && typeof messages === 'object') {
    const out: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(messages)) {
      out[key] = adaptForVueI18n(value)
    }
    return out as T
  }
  return messages
}

export const i18n = createI18n({
  legacy: false,
  locale: 'tr',
  fallbackLocale: 'tr',
  messages: {
    tr: adaptForVueI18n(tr),
    en: adaptForVueI18n(en),
  },
  // Eksik çeviri uyarısı geliştirmede görünür olsun, üretimde konsolu doldurmasın.
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
})

export function setI18nLocale(locale: SupportedLocale) {
  i18n.global.locale.value = locale
  document.documentElement.setAttribute('lang', locale)
}
